export const getCharacterizationTabs = (t) => [
  { id: "review", label: t("Review") },
  { id: "reports", label: t("Reports") },
  { id: "history", label: t("Revision history") },
  { id: "files", label: t("Files") },
];

export const DEFAULT_ACTIVE_TAB = "review";
